import {  useNavigate } from "react-router-dom"
import projects from "../json/projects.json"
import { useRef, useState } from "react"
import parse from 'html-react-parser'
import "../css/Projects.css"

const ProjectForm = () => {

    const tag = window.location.href.substring(window.location.href.lastIndexOf("/") + 1)
    const project = projects.filter(p => p.tag === tag)[0]
    const slideshowImagesArray = project.images
    const [slideshowImage, setSlideshowImage] = useState(slideshowImagesArray[0])
    const navigate = useNavigate()
    const slider = useRef("")


    function changeSlideshowImage(direction) {

        let currentImage
        if (direction !== "left" && direction !== "right") return
        const index = slideshowImagesArray.indexOf(slideshowImage)
        const length = slideshowImagesArray.length
        if (index === 0 && direction === "left") {
            currentImage = slideshowImagesArray[length - 1]
            return
        }
        if (index === length - 1 && direction === "right") {
            currentImage = slideshowImagesArray[0]
            return
        }
        currentImage = slideshowImagesArray[(direction === "left") ? index - 1 : index + 1]
        setSlideshowImage(currentImage)
        scrollToImage(currentImage)

    }

    function setImage(img) {
        setSlideshowImage(img)
        scrollToImage(img)
    }

    function scrollToImage(img){
        slider.current.scrollLeft = slideshowImagesArray.indexOf(img) * 82
    }


    return (
        <main className="flex col jcenter acenter">
            <section className="flex acenter col pad-10" >
                <section className="flex gap-10 backlink" onClick={() => navigate("/proyectos")}>
                    <i className="bi bi-arrow-left"></i>
                    <label className="pointer">Volver al listado de proyectos</label>
                </section>


            </section>

            <section className="project-card">

                <section className="project-data">
                    <h1 className="flex cspica jcenter project-title ">{project.largetitle}</h1>
                    <div className="bbwine"></div>
                    {project.items.map(item =>
                        (item.content.includes("<ul>")) ?
                            <div key={item.id} className="tjustify">{parse(item.content)}</div> :
                            <p key={item.id} className="tjustify">{parse(item.content)}</p>
                    )}
                </section>
                <section className="project-slideshow">

                    <section className="flex pad-10">
                        <img className="main-image" alt={slideshowImage.name} src={"/images/projects/" + slideshowImage.name} target="_blank"></img>
                    </section>

                    <section className="slideshow-area flex acenter">
                        <i className="bi bi-caret-left-fill black-icon" onClick={() => changeSlideshowImage("left")}></i>

                        <section ref={slider} className="flex overflow-x gap-10 pad-10" >
                            {slideshowImagesArray.map(image =>
                                <img id={image.id} key={image.id} alt={image.name} className={(image === slideshowImage) ? "secondary-image selected pointer" : "secondary-image pointer"} src={"/images/projects/" + image.name} onClick={() => setImage(image)}></img>
                            )}
                        </section>

                        <i className="bi bi-caret-right-fill black-icon" onClick={() => changeSlideshowImage("right")}></i>
                    </section>
                </section>
            </section>
        </main >
    )
}

export default ProjectForm